// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/img/loader.gif", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: "Inter", sans-serif;
  font-weight: 200;
  font-style: normal;
  overflow: hidden;
  font-optical-sizing: auto;
}

.body-overflow-auto {
  overflow: auto !important;
}

.main-content {
  display: flex;
  height: calc(var(--vh) * 100) !important;
  width: 100%;
  justify-content: space-between;
  flex-wrap: wrap;
}
.main-content-bg::after {
  content: "";
  width: 100%;
  height: 100%;
  background-color: #629A33;
  display: flex;
  position: absolute;
  opacity: 0.3;
  z-index: 0;
}

h2 {
  font-family: "Inter", serif;
  font-weight: 300;
  font-size: 17px;
  line-height: 100%;
}

.hide-visible {
  visibility: hidden;
  display: none;
}

input {
  border: none;
  padding: 0;
  margin: 0;
  background: none;
  font: inherit;
  color: inherit;
  outline: none;
  box-shadow: none;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

form > .option:hover {
  transition: all 0.3s;
  transform: translateY(-3px);
}

.hotspot {
  position: absolute;
  width: 90px;
  height: 75px;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
  pointer-events: auto;
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.hotspot:hover {
  transform: scale(1.2);
}

.hidden {
  opacity: 0;
  pointer-events: none;
}

.app-loader::after {
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 500px;
  background-position: center;
  background-repeat: no-repeat;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 999999;
  top: 0;
  background-color: #ffffff;
}

.footer-h {
  display: none;
}

#ar-prompt {
  position: absolute;
  left: 50%;
  bottom: 60px;
  animation: 2s ease-in-out 0s infinite alternate none running elongate;
  animation-duration: 2s;
  animation-timing-function: ease-in-out;
  animation-delay: 0s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  animation-fill-mode: none;
  animation-play-state: running;
  animation-name: elongate;
  display: none;
}

@keyframes elongate {
  from {
    transform: translateX(100px);
  }
  to {
    transform: translateX(-100px);
  }
}
@keyframes circle {
  from {
    transform: translateX(-50%) rotate(0deg) translateX(50px) rotate(0deg);
  }
  to {
    transform: translateX(-50%) rotate(360deg) translateX(50px) rotate(-360deg);
  }
}
#ar-prompt > img {
  animation: circle 4s linear infinite;
}

model-viewer {
  width: 100%;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/styles/main.scss","webpack://./src/styles/_variables.scss","webpack://./src/styles/_mixins.scss"],"names":[],"mappings":"AAGA;EACE,SAAA;EACA,UAAA;EACA,sBAAA;AAFF;;AAKA;EACE,gCAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;AAFF;;AAKA;EACE,yBAAA;AAFF;;AAKA;EACE,aAAA;EACA,wCAAA;EACA,WAAA;EACA,8BAAA;EACA,eAAA;AAFF;AAKI;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,yBC9BS;ED+BT,aAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;AAHN;;AAQA;EEXE,2BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AFOF;;AAKA;EACE,kBAAA;EACA,aAAA;AAFF;;AAKA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,wBAAA;EACA,qBAAA;AAFF;;AAME;EACE,oBAAA;EACA,2BAAA;AAHJ;;AAOA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,2BAAA;EACA,eAAA;EACA,oBAAA;EACA,kDAAA;AAJF;;AAOA;EACE,qBAAA;AAJF;;AAOA;EACE,UAAA;EACA,oBAAA;AAJF;;AAQE;EACE,WAAA;EACA,yDAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,MAAA;EACA,yBCnGU;AD8Fd;;AASA;EACE,aAAA;AANF;;AAUA;EACE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,qEAAA;EACA,sBAAA;EACA,sCAAA;EACA,mBAAA;EACA,mCAAA;EACA,8BAAA;EACA,yBAAA;EACA,6BAAA;EACA,wBAAA;EACA,aAAA;AAPF;;AAUA;EACE;IACE,4BAAA;EAPF;EAUA;IACE,6BAAA;EARF;AACF;AAWA;EACE;IACE,sEAAA;EATF;EAYA;IACE,2EAAA;EAVF;AACF;AAaA;EACE,oCAAA;AAXF;;AAcA;EACE,WAAA;EACA,YAAA;AAXF","sourcesContent":["@use \"./variables\" as vars;\n@use \"./mixins\" as mix;\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 200;\n  font-style: normal;\n  overflow: hidden;\n  font-optical-sizing: auto;\n}\n\n.body-overflow-auto {\n  overflow: auto !important;\n}\n\n.main-content {\n  display: flex;\n  height: calc(var(--vh) * 100) !important;\n  width: 100%;\n  justify-content: space-between;\n  flex-wrap: wrap;\n\n  &-bg {\n    &::after {\n      content: \"\";\n      width: 100%;\n      height: 100%;\n      background-color: vars.$second-color;\n      display: flex;\n      position: absolute;\n      opacity: 0.3;\n      z-index: 0;\n    }\n  }\n}\n\nh2 {\n  @include mix.h2();\n}\n\n.hide-visible {\n  visibility: hidden;\n  display: none;\n}\n\ninput {\n  border: none;\n  padding: 0;\n  margin: 0;\n  background: none;\n  font: inherit;\n  color: inherit;\n  outline: none;\n  box-shadow: none;\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n}\n\nform {\n  &>.option:hover {\n    transition: all 0.3s;\n    transform: translateY(-3px);\n  }\n}\n\n.hotspot {\n  position: absolute;\n  width: 90px;\n  height: 75px;\n  background-repeat: no-repeat;\n  background-position: center;\n  cursor: pointer;\n  pointer-events: auto;\n  transition: transform 0.2s ease, opacity 0.2s ease;\n}\n\n.hotspot:hover {\n  transform: scale(1.2);\n}\n\n.hidden {\n  opacity: 0;\n  pointer-events: none;\n}\n\n.app-loader {\n  &::after {\n    content: \"\";\n    background-image: url(../../public/img/loader.gif);\n    background-size: 500px;\n    background-position: center;\n    background-repeat: no-repeat;\n    width: 100vw;\n    height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: fixed;\n    z-index: 999999;\n    top: 0;\n    background-color: vars.$white-color;\n  }\n}\n\n.footer-h {\n  display: none;\n}\n\n//#region AR\n#ar-prompt {\n  position: absolute;\n  left: 50%;\n  bottom: 60px;\n  animation: 2s ease-in-out 0s infinite alternate none running elongate;\n  animation-duration: 2s;\n  animation-timing-function: ease-in-out;\n  animation-delay: 0s;\n  animation-iteration-count: infinite;\n  animation-direction: alternate;\n  animation-fill-mode: none;\n  animation-play-state: running;\n  animation-name: elongate;\n  display: none;\n}\n\n@keyframes elongate {\n  from {\n    transform: translateX(100px);\n  }\n\n  to {\n    transform: translateX(-100px);\n  }\n}\n\n@keyframes circle {\n  from {\n    transform: translateX(-50%) rotate(0deg) translateX(50px) rotate(0deg);\n  }\n\n  to {\n    transform: translateX(-50%) rotate(360deg) translateX(50px) rotate(-360deg);\n  }\n}\n\n#ar-prompt>img {\n  animation: circle 4s linear infinite;\n}\n\nmodel-viewer {\n  width: 100%;\n  height: 100%;\n}\n\n//#endregion","$primary-color: #629A33;\n$secondary-color: #6c757d;\n$font-size-base: 16px;\n$second-color: #629A33;\n$second-color-1: #06aeef;\n$shadow-color: #47659314;\n$black-color:  #1A1A1A;\n$black-color-second: #3A3A3C;\n$white-color: #ffffff;\n$red-color: #ff214a;\n\n$margin-top-title-option: 10px;\n$padding-vertical-group-inputs: 20px;\n$width-interface: 39vw;\n","@use \"variables\" as vars;\n\n@mixin text-center {\n  text-align: center;\n}\n\n@mixin font-family {\n  font-family: \"Inter\", serif;\n}\n\n@mixin font-family-second {\n   font-family: \"Inter\", serif;\n}\n\n@mixin box-border($blur, $color) {\n  border: 0.5px solid $color;\n}\n\n@mixin box-border-solid($blur, $color) {\n  border: 1px solid $color;\n}\n\n@mixin box-shadow($color) {\n  box-shadow: 0px 0px 20px 0px rgba($color, 0.1);\n}\n\n@mixin radius() {\n  border-radius: 10px;\n}\n\n@mixin h2() {\n  font-family: \"Inter\", serif;\n  font-weight: 300;\n  font-size: 17px;\n  line-height: 100%;\n}\n\n@mixin h3() {\n  font-family: \"Inter\", serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 21px;\n}\n\n@mixin h4() {\n  font-family: \"Inter\", serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 21px;\n  text-align: left;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n}\n\n@mixin h5() {\n  font-family: \"Inter\", serif;\n  font-size: 10px;\n  font-weight: 400;\n  line-height: 12px;\n  text-align: center;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n}\n\n@mixin bold {\n  font-family: \"Inter\", serif;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
